import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the GetFileImgPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'getFileImg',
})
export class GetFileImgPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: any, args?: any): any {
    let img = 'default';
    let imgs = [
      {reg:'.txt',img:'text'},
      {reg:'.pdf',img:'pdf'},
      {reg:'.xls',img:'excel'},
      {reg:'.doc',img:'word'}
    ];

    imgs.forEach(item => {
      if(value.toLowerCase().indexOf(item.reg) != -1){
        img = item.img;
      }
    });
    return './assets/imgs/'+ img+ '.png';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/get-file-img/get-file-img.ts